import { create as createStore } from 'zustand';

interface IStore {
  isOpen: boolean;
  openMoveFlashcardForm: () => void;
  closeMoveFlashcardForm: () => void;
  flashcardId: string | null;
  setFlashcardId: (flashcardId: string) => void;
}

export const useMoveFlashcardToCollection = createStore<IStore>(set => ({
  isOpen: false,
  flashcardId: null,
  openMoveFlashcardForm: () => {
    set({ isOpen: true });
  },
  closeMoveFlashcardForm: () => {
    set({ isOpen: false, flashcardId: null });
  },
  setFlashcardId: (flashcardId: string) => {
    set({ flashcardId });
  }
}));
